import React, { Component } from "react";
import BykZakladni from "./BykZakladni/BykZakladni";
import TextSvisle from "../TextSvisle/TextSvisle";
import "./IBZakladni.css";
import Items from '../Items/Items';
import { connect } from "react-redux";

class IBZakladni extends Component {
  render() {
    const uvodNadpis = 'Základní dělení - úvod'
    const uvod = 'Skot se v základu dělí na přední a zadní čtvrť, které obsahují 13 základních částí. Do přední čtvrti patří Krk, Vysoký roštěnec, Plec, Přední žebro, Hrudí a Přední kližka. Do zadní čtvrti patří Nízký roštěnec, Svíčková, Bok s kostí, Bok bez kosti, Kytá, Zadní kližka, Oháňka. Těchto 13 základních částí potom můžeme rozbourat na 30 částí. Pro rozdělení, popis a fotky těchto 30 částí klikněte na "Kompletní zobrazení".'
    const { animalPartId, name, img, textSvis } = this.props;
    let text = (
        <TextSvisle name={uvodNadpis} text={uvod} />
    );

    if (this.props.show) {
      text = (
        <TextSvisle id={animalPartId} name={name} img={img} text={textSvis} />
      );
    }
   // console.log("props prosli", img);

    return (
      <div className="KurzContainerZakladni">
      <div style={{opacity:'0'}}>
      <Items />
      </div>
        <div className="KurzAnimalContainerZakladni">
          <BykZakladni />
        </div>

        {text}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    animalPartId: state.text.animalPartId,
    name: state.text.name,
    img: state.text.img,
    img2: state.text.img2,
    textSvis: state.text.textSvis,
    show: state.text.show
  };
};

export default connect(mapStateToProps)(IBZakladni);
